"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dompurify = _interopRequireDefault(require("dompurify"));
var _common = require("../../config/common");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _useContentService = _interopRequireDefault(require("../../utils/hooks/useContentService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Component to load content asynchronously
 *
 * @visibleName Async Content Fragment
 * @author Eric Shoemaker
*/
const AsyncContentFragment = props => {
  const {
    htmlElem = "div",
    resourceUrl,
    ...rest
  } = props;
  const HTMLElem = htmlElem;
  const contentService = (0, _useContentService.default)({
    url: resourceUrl
  });
  const contentFragmentProps = {};
  if (contentService.status === "loaded") {
    contentFragmentProps.dangerouslySetInnerHTML = {
      __html: _dompurify.default.sanitize(contentService.payload, _common.DOM_PURIFY_OPTIONS)
    };
  } else if (contentService.status === "error") {
    contentFragmentProps.children = /*#__PURE__*/_react.default.createElement("div", null, "Error message: ", contentService.error);
  } else {
    contentFragmentProps.children = /*#__PURE__*/_react.default.createElement("div", null, "Loading...");
  }
  return /*#__PURE__*/_react.default.createElement(HTMLElem, _extends({}, rest, contentFragmentProps, {
    "data-resource-id": resourceUrl
  }));
};

// Define propTypes;
AsyncContentFragment.propTypes = {
  /** String to be used as HTML Element (Default Value: "div") */
  htmlElem: _propTypes.default.string,
  /** String to be output */
  resourceUrl: _propTypes.default.string.isRequired
};

// Export component as default;
var _default = exports.default = AsyncContentFragment;